import { render, staticRenderFns } from "./SecondStrategy.vue?vue&type=template&id=3c796014&scoped=true"
import script from "./SecondStrategy.vue?vue&type=script&scoped=true&lang=js"
export * from "./SecondStrategy.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./SecondStrategy.vue?vue&type=style&index=0&id=3c796014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c796014",
  null
  
)

export default component.exports